import Header from "@/components/UI/Header"
import Footer from "@/components/UI/Footer"

export default [
    Header,
    Footer
]